import React from 'react';
import './Events.css'
import SideMenu from '../Components/Layout/SideMenu';
import TopBar from '../Components/Layout/TopBar';
import PageHeader from '../Components/Common/PageHeader';
import EventsPageTable from '../Components/Common/EventsPageTable';

const Events = () => {
    return ( <main>
        <SideMenu />

        <div className='DashMain'>
            <TopBar PageTitle="Events"/>

            <div className='DashContent'>
                <PageHeader HeaderTitle="Events Management" HeaderSub="Manage all your events and ticket sales" PageHeaderStyle="PageHeader" BtnText="+ Add Event"/>

                <EventsPageTable />
            </div>
        </div>
    </main>);
}
 
export default Events;